module.exports = __webpack_public_path__ + "img/02-data.026eb9dd.png";